module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/header-image-mobile-04-c3cce12b8e3efb6951d360d7281cef17.jpg";